'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import styles from './SleepScoreModal.module.css';

export const SleepScoreModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="sleep-score-modal-heading"
    >
      {/* <div className="close-btn">
            <button>
              <CrossDark />
            </button>
          </div> */}
      <div className="container">
        {/* <h4>Sleep Score</h4>
          <h3>Your entire Sleep summed up</h3> */}
        <h4 id="sleep-score-modal-heading">
          {t('ring.bentoSleepSection.sleepCard.modal.head')}
        </h4>
        <h3>{t('ring.bentoSleepSection.sleepCard.modal.subHead')}</h3>
        <div className="modal-items">
          <div className="item">
            {/* <p className="text-mid">
                The Ultrahuman Ring AIR provides a Sleep Score as part of your
                Sleep Index that assigns{' '}
                <span className="bold"> a score out of 100 to your sleep.</span>{' '}
                This score is based on your performance with respect to 11+
                sleep contributors and time spent across different sleep stages.
                The Sleep Score summarizes your sleep into a quantitative score
                out of 100. While seemingly straightforward, the anatomy of your
                sleep, made up of Sleep Contributors, has a role to play in
                determining this score. Your performance in these Sleep
                Contributors, along with the time spent in different sleep
                stages, together make up your Sleep Score. By tracking your
                sleep and following personalized nudges, you can make lifestyle
                changes that will help you improve your sleep.
              </p> */}
            <p className="text-mid">
              {t('ring.bentoSleepSection.sleepCard.modal.cardA.descA')}{' '}
              <span className="bold">
                {t('ring.bentoSleepSection.sleepCard.modal.cardA.descBold')}
              </span>{' '}
              {t('ring.bentoSleepSection.sleepCard.modal.cardA.descB')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t(
                'sleepScoreModal.content.ariaLabel.sleepScoreAlgorithm',
              )}
            >
              {width > 992 ? (
                // <Image
                //   src={'web_v2/ring-buy/sleep/png/flip/sleepScoreFlipAlg.png'}
                //   fill
                //   alt="sleep-score-modal"
                //   className="sleep-score-modal"
                // />
                <Image
                  src={'web_v2/ring-buy/sleep/png/flip/sleepScoreFlipAlg.png'}
                  fill
                  alt=""
                  className="sleep-score-modal"
                  aria-hidden="true"
                />
              ) : (
                <Image
                  src={'web_v2/ring-buy/sleep/png/flip/sleepScoreFlipAresp.png'}
                  fill
                  alt=""
                  className="sleep-score-modal"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
